module.exports = "../fonts/vendor/primevue/resources/themes/lara-light-indigo/Inter-Regular.woff?8c206db99195777c67691cbba9d64393";